import { render, staticRenderFns } from "./perfiles-cargo-ver.vue?vue&type=template&id=1d3bf629&scoped=true&"
import script from "./perfiles-cargo-ver.vue?vue&type=script&lang=js&"
export * from "./perfiles-cargo-ver.vue?vue&type=script&lang=js&"
import style0 from "./perfiles-cargo-ver.vue?vue&type=style&index=0&id=1d3bf629&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3bf629",
  null
  
)

export default component.exports